var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"mt-2",attrs:{"color":"primary","small":"","block":"","text":""}},[_c('v-icon',{staticClass:"mr-1"},[_vm._v(" mdi-account-details-outline ")]),_vm._v(" Details ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }